module.exports = __webpack_public_path__ + "static/media/logo.37fa3514.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/branding/logo.svg
 ** module id = 595
 ** module chunks = 0
 **/